"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorshipProperty = exports.authorshipPropertyDefinition = void 0;
exports.authorshipPropertyDefinition = {
    view: { label: 'Authorship' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'properties',
            argument: ['authorship-author', 'authorship-link'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'authorship',
};
const isAuthorshipProperty = (prop) => {
    return prop.name === exports.authorshipPropertyDefinition.name;
};
exports.isAuthorshipProperty = isAuthorshipProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yc2hpcC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2F1dGhvcnNoaXAucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFO0lBQzdCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLENBQUMsbUJBQW1CLEVBQUUsaUJBQWlCLENBQUM7U0FDbkQ7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxJQUFrQixFQUE4QixFQUFFO0lBQ3JGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvQ0FBNEIsQ0FBQyxJQUFJLENBQUE7QUFDeEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=